import axios from 'axios';

export default {
  get: function (request) {
    return axios.get('/api/exportpotential/upload', { params: request });
  },
  search: function (data) {
    let params = Object.keys(data)
      .map((param) => {
        if (param === 'ParrentsCodesNsiTnved') {
          return data[param].map((item) => param + '=' + item).join('&');
        }
        return param + '=' + data[param];
      })
      .join('&');
    return axios.get('/api/exportpotential/search?' + params);
  },
  // getCountry: () => {
  //   return axios.get('/api/nsi/countryList', {})
  // },
  getProductsList: async (request) => {
    return axios.get('/api/nsi/nsitnved/search', { params: request });
  },
  getProductsListWithExportPotential: async (request) => {
    return axios.get('/api/exportpotential/getProductList?', { params: request });
  },
};
